import { render, staticRenderFns } from "./RadioItemOptional.vue?vue&type=template&id=12de05ea&scoped=true&"
import script from "./RadioItemOptional.vue?vue&type=script&lang=js&"
export * from "./RadioItemOptional.vue?vue&type=script&lang=js&"
import style0 from "./RadioItemOptional.vue?vue&type=style&index=0&id=12de05ea&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de05ea",
  null
  
)

export default component.exports